import type { User } from 'oidc-client-ts'

export function buildAuthorizationHeader(user: User | null): { Authorization: string } | undefined {
  if (user?.access_token) {
    const authorizationTokenFormat = {
      access_token: user.access_token,
      id_token: user.id_token || '',
    }
    return {
      Authorization: JSON.stringify(authorizationTokenFormat),
    }
  }
  return undefined
}
